import {StorageEngine} from '@ngxs/storage-plugin';

// import {Preferences} from "@capacitor/preferences";

export class PersistentStorageEngine implements StorageEngine {
  get length(): number {
    // Your logic here
    return 1;
  }

  getItem(key: string): any {
    // const ret = await Preferences.get({key});
    // return ret.value;

    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.error("error by getting localstorage item, " + key, e);
    }
  }

  setItem(key: string, val: any): any {
    try {
      localStorage.setItem(key, val);
    } catch (e) {
      console.error("error by setting localstorage item, " + key, e);
    }

    // Preferences.set({
    //  key,
    //  value: val
    // });
  }

  removeItem(key: string): void {
    // Your logic here
  }

  clear(): void {
    // Your logic here
  }
}
